import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { useConnectAccount } from 'components/BrandKitCreationModal/useConnectAccount'
import { usePostPreviewStore } from 'components/PostPreviewModalV2/PostPreviewStoreProvider'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { useCreateBrandKitSource } from 'hooks/queries/useCreateBrandKitSource'
import { uniqBy } from 'lodash'
import { observer } from 'mobx-react-lite'

export const ConnectAccountButton = observer(({ provider }: { provider: ExternalIntegrationEnum }) => {
  const { mutateAsync: createBrandKitSource } = useCreateBrandKitSource()
  const { data: brandKits } = useBrandKits()
  const store = usePostPreviewStore()

  const onConnect = async (accounts: ExternalIntegration[]) => {
    const brandKit = brandKits?.find((b) => b.id === store.selectedBrandKitId)
    if (!brandKit || accounts.length === 0) return

    await createBrandKitSource({
      brandKitId: brandKit.id,
      source: { type: 'ExternalIntegration', id: accounts[0].id },
    })

    store.setSelectedAccounts(uniqBy([...store.selectedAccounts, ...accounts], 'id'))
    store.addChannel(accounts[0].provider)
  }

  const connect = useConnectAccount({ onConnect })

  return (
    <Button variant="primary" onPress={() => connect(provider)} size="lg" fullWidth>
      Connect Account to Schedule or Post
    </Button>
  )
})
